<template>
  <div>
    <div class="raise-up-a-bit">
      <span v-show="showHeadings()" align="center" :class="getProgressHeadingClass()">{{ getLabel() }}</span>
    </div>
    <div :class="getProgressClass()">
      <div class="progress-bar" aria-hidden="true" aria-label="bar" role="progressbar" :aria-valuenow="getProgressValue()" aria-valuemin="0" aria-valuemax="100" :style="getProgressStyle()"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    bar: {
      type: String,
      default: "0", // 0..3
    },
    headings: {
      type: String,
      default: "no",
    },
    percentOverride: {
      type: String,
      default: "-1",
    },
  },
  components: {},
  data() {
    return {
      // Arrays
      bars: [
        {
          id: "bar1",
          label: "Bien-être", // LG_progressBarLabel1
          color: "#ACB203",
        },
        {
          id: "bar2",
          label: "Engagement", // LG_progressBarLabel2
          color: "#C02234",
        },
        {
          id: "bar3",
          label: "Expression", // LG_progressBarLabel3
          color: "#58A8AE",
        },
        {
          id: "bar4",
          label: "Appartenance", // LG_progressBarLabel4
          color: "#D4880C",
        },
      ],

      // Text

      // Images

      // Variables
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getProgressHeadingClass() {
      if (this.newVersion()) {
        return "progress-heading-new";
      }
      return "progress-heading";
    },
    getProgressClass() {
      if (this.newVersion()) {
        return "progress progress-bar-back-new";
      }
      return "progress progress-bar-back";
    },
    showHeadings() {
      if (this.headings == "yes") {
        return true;
      }
      return false;
    },
    getBar() {
      var index = Number(this.bar);
      return this.bars[index];
    },
    getLabel() {
      if (this.newVersion()) {
        var percent = Math.round(this.getProgressValue());
        return this.getBar().label + ": " + percent + "%";
      }
      return this.getBar().label;
    },
    getProgressValue() {
      if (this.percentOverride != "-1") {
        var val = Number(this.percentOverride);
        return val;
      }

      var index = Number(this.bar);
      return this.getProgressBarValue(index);
    },
    getProgressColor() {
      var index = Number(this.bar);

      if (index >= 0 && index < this.bars.length) {
        return this.bars[index].color;
      }
      return "white";
    },
    getProgressStyle() {
      var value = this.getProgressValue();
      var color = this.getProgressColor();
      var style = "width:" + value + "%; background-color:" + color + " !important;";
      return style;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.progress-heading {
  color: white;
  width: 100%;
  font-size: 12px;
}

.progress-heading-new {
  color: #225970;
  width: 100%;
  font-size: 12px;
  font-weight: bold;
}

.progress-bar-back {
  background-color: #052433 !important; /*#38163E  */
  width: 100%;
}

.progress-bar-back-new {
  background-color: white !important; /*#38163E  */
  width: 100%;
  border: 1px solid #7a7b7b;
}

@media only screen and (max-width: 800px) {
  .progress-heading {
    color: white;
    width: 100%;
    font-size: 12px;
  }
}

.raise-up-a-bit {
  position: relative;
  bottom: 3px;
  left: 3px;
}
</style>
